import jQuery from "jquery";
import {numberFilter} from "../../../admin/script/util/numbers.js";

let pkDOMContentLoadedInitialized = false;
document.addEventListener("DOMContentLoaded", function (event) {
    if (pkDOMContentLoadedInitialized) {
        return;
    }
    pkDOMContentLoadedInitialized = true;

    jQuery('#exampleModal').on('show.bs.modal', function (event) {
        const button = $(event.relatedTarget);
        const recipient = button.data('whatever');
        const modal = $(this);
        modal.find('.modal-title').text('New message to ' + recipient);
        modal.find('.modal-body input').val(recipient)
    });

    jQuery('a[rel="show-container"]').on('click', function() {
        const id = jQuery(this).data('id');
        if (typeof id === 'undefined' || id === null) {
            return;
        }
        jQuery('#'+id).slideDown();
        return false;
    });

    jQuery('.show-container-and-hide-myself').on('click', function() {
        const id = jQuery(this).data('id');
        if (typeof id === 'undefined' || id === null) {
            return;
        }
        const divcontainer = jQuery('#' + id);
        if(divcontainer.is(":hidden")){
            if(divcontainer.hasClass('d-none')){
                divcontainer.removeClass('d-none').hide();
            }
            divcontainer.slideDown("slow");
        } else {
            divcontainer.slideUp("slow");
        }
        return false;
    });

    jQuery('a[rel="new-window"]').on('click', function() {
        const hrefValue = jQuery(this).attr('href');
        window.open(hrefValue ,"Window",'width=800,height=600,resizable=0,scrollbars=yes,menubar=no');
        return false;
    });

    jQuery(document).on('click', 'a[data-action="download-file"]', function (e) {
        const button = e.currentTarget;
        if (button.href) {
            e.preventDefault();
            POLKURIER.downloadUrlFile(button.href, button);
        }
    });

    jQuery(document).on('click','a[rel="new-temp-window"]',function() {
        var hrefValue = jQuery(this).attr('href');
        window.open(hrefValue, "Window", 'width=1,height=1,resizable=0,scrollbars=yes,menubar=no');
        return false;
    });

    jQuery('[rel="toggle-block"]').on('click', function() {
        const blockSelector = jQuery(this).data('block');
        const classOn = jQuery(this).data('class-on');
        const classOff = jQuery(this).data('class-off');
        if (typeof blockSelector === 'undefined' || blockSelector === null || blockSelector.length < 1) {
            return;
        }

        const $block = jQuery(blockSelector);
        if ($block.length < 1) {
            return;
        }

        if ($block.is(':visible')) {
            jQuery(this)
                .removeClass(classOn)
                .addClass(classOff);
            $block.slideUp();
        } else {
            jQuery(this)
                .removeClass(classOff)
                .addClass(classOn);
            $block.slideDown();
        }
    });

    jQuery('a[rel="pk-ajax-notification"]').on('click', function() {
        const link = jQuery(this).attr('href');
        jQuery.ajax({
            url: link,
            type: 'GET',
            success: function(xmlHttpRequest) {
                ajaxNotification(xmlHttpRequest);
            }
        });
        return false;
    });


    // Dodaje klasę do pozycji menu jeśli nie dodano ręcznie (aby wyświetlić strzałeczkę)
    jQuery('.pk-left-menu .submenu').each((i, e) => {
        jQuery(e).parent().addClass('has-submenu');
    });

    // Otwieranie / zamykanie podmenu
    const $leftMenu = jQuery('.pk-left-menu');
    $leftMenu.on('click', 'a', e => {
        const $element = jQuery(e.currentTarget);
        const $listItem = $element.parent();
        const $submenu = $listItem.find('.submenu');

        if (!$submenu || !$submenu.length) {
            return true;
        }

        if ($listItem.hasClass('active')) {
            $submenu.slideUp(() => {
                $listItem.removeClass('active');
            });
            return false;
        }

        $leftMenu.find('.active .submenu').slideUp(function () {
            jQuery(this).parent().removeClass('active');
        });

        $submenu.slideDown(() => {
            $listItem.addClass('active');
        });
        $listItem.addClass('active');

        return false;
    });




    jQuery(function($){
        jQuery(document).on(/Opera/.test(navigator.userAgent) ? "keydown" : "keypress",".ctype_digit_dot",function(e){
            if(/Opera/.test(navigator.userAgent)){
                if(e.which === 110 && this.value.indexOf('.') === -1){
                    e.preventDefault();
                    return jQuery(this).val(jQuery(this).val() + ".");
                }else{
                    return e.which === 8 || e.which === 46 || ( e.which === 190 && this.value.indexOf('.') === -1) || ( e.which >= 48 && e.which <= 57 ) || ( e.which >= 96 && e.which <= 105 );
                }
            }else{
                if(e.which === 44 && this.value.indexOf('.') === -1){
                    e.preventDefault();
                    return jQuery(this).val(jQuery(this).val() + ".");
                }else{
                    return e.which === 8 || e.which === 0 || (e.which === 46 && this.value.indexOf('.') === -1) || (e.which >= 48 && e.which <= 57);
                }
            }
        });

        jQuery(document).on('paste', '.ctype_digit_dot', e => {
            e.preventDefault();
            const previousValue = e.target.value;
            e.target.value = String(numberFilter(e.originalEvent.clipboardData.getData('text/plain')));
            e.target.dispatchEvent(new Event('input', {bubbles: true}));
            if (e.target.value !== previousValue) {
                e.target.dispatchEvent(new Event('change', {bubbles: true}));
            }
        });
    });




    jQuery(function($){
        jQuery(document).on("keyup",".ctype_digit",function(e){
            var val_input = jQuery(this).val();
            jQuery(this).val(val_input.replace(/[^\d]+/g,''));
        });
    });

    jQuery.fn.pkTextareaCharacterCounter = function (options = {}) {
        options = {
            counter: null,
            format: '{length} / {maxlength}',
            ...(options) || {},
        };
        const getCounter = ($element) => {
            if ($element[0].__counterElement) {
                return jQuery($element[0].__counterElement);
            }
            let $counter;
            if (options.counter instanceof jQuery) {
                $counter = options.counter;
            } else if (typeof options.counter === 'string' && options.counter.indexOf('#') === 0) {
                $counter = jQuery(options.counter);
            } else {
                $counter = jQuery('<div>', {class: 'form-block text-right text-muted counted-textarea-counter'});
                $element.after($counter);
            }
            $element[0].__counterElement = $counter[0];
            return $counter;
        };
        return jQuery(this).each(function () {
            if (this.tagName === 'TEXTAREA' || (this.tagName === 'INPUT' && this.type === 'text')) {
                const $textarea = jQuery(this);
                const update = function () {
                    const $counter = getCounter($textarea);
                    $counter.text(
                        options.format
                            .replace('{length}', $textarea.val().length)
                            .replace('{maxlength}', $textarea.attr('maxlength'))
                        );
                };
                $textarea.on('keyup change input', update);
                update();
            }
            return this;
        })
    };

    (function () {
        let passwordWrapper;
        for (let el of document.querySelectorAll('input[type=password]')) {
            if (el.parentElement?.tagName !== 'PK-SHOW-PASSWORD') {
                passwordWrapper = document.createElement('pk-show-password');
                el.parentElement.insertBefore(passwordWrapper, el);
                passwordWrapper.appendChild(el);
            }
        }
    }());

});
